<!-- 任务汇报 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <!-- <template v-slot:next>
          <el-button icon="el-icon-plus" @click="$router.push('taskReport/form')">新增</el-button>
        </template> -->
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteTaskReport } from "@/api/bill/taskReport";

export default {
  name: "TaskReport",
  mixins: [DataTableMixin],
  components: {
    DynamicSearch
  },
  data() {
    return {
      delLoading: false,
      tableHead: [
        {
          label: "单据编号",
          prop: "documentNum",
          query: {
            type: "input"
          },
          align: "left"
        },
        {
          label: "项目号",
          prop: "projectNum",
          query: {
            type: "input"
          },
          align: "left"
        },
        {
          label: "工作分配日期",
          prop: "workAlloctionTime"
        },
        {
          label: "项目节点",
          prop: "projectNode"
        },
        {
          label: "里程碑节点",
          prop: "milestoneNode"
        },
        {
          label: "任务节点编号",
          prop: "taskNodeNumber"
        },
        {
          label: "任务内容",
          prop: "taskContent"
        },
        {
          label: "具体工作",
          prop: "specificWork"
        },
        {
          label: "任务接收人",
          prop: "taskClass"
        },
        {
          label: "工作汇报",
          prop: "workReport"
        },
        {
          label: "完成",
          prop: "accomplishCondition"
        },
        {
          label: "备注",
          prop: "remark"
        }
      ],
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/BizTaskReport/findList"
      const params = {current: this.page, size: this.offset}
      this._params = Object.assign(params, this._query)
      return true
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      deleteTaskReport(id)
        .then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
        })
        .catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err);
        });
    },
    edit(row) {
      console.log(row);
      this.$router.push("taskReport/form?id=" + row.id);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
